import { message, Upload } from 'antd';

export const IMAGE_ACCEPT = 'image/jpeg,image/png';

// Returning LIST_IGNORE (not false) makes antd drop the file from fileList, otherwise onChange still receives it
export function checkFileIsImage(file: File) {
  if (file.type === 'image/jpeg' || file.type === 'image/png') {
    return true;
  }

  message.error('Aplikace podporuje pouze obrázky ve formátu JPG nebo PNG');
  return Upload.LIST_IGNORE;
}
